/// <amd-module name="CodeCoverage/AllTab/AllTabViewService" />
import { ObservableValue, ObservableLike } from "VSS/Core/Observable";
import { caseInsensitiveContains } from "VSS/Core/Util/String";
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { ITreeItem } from "VSSUI/Utilities/TreeItemProvider";

import { ICodeCoverageTreeItem } from "CodeCoverage/AllTab/Contracts";
import { getFileName, getParentPaths } from "CodeCoverage/AllTab/Helpers";

export interface IAllTabViewService extends IVssService {
    filterItems(
        filterText: string,
        items: { [key: string]: ITreeItem<ICodeCoverageTreeItem | ObservableValue<ICodeCoverageTreeItem | undefined>> }
    ): (ICodeCoverageTreeItem | ObservableValue<ICodeCoverageTreeItem | undefined>)[];
}

export class AllTabViewService extends VssService implements IAllTabViewService {
    public filterItems(
        filterText: string,
        items: { [key: string]: ITreeItem<ICodeCoverageTreeItem | ObservableValue<ICodeCoverageTreeItem | undefined>> }
    ): (ICodeCoverageTreeItem | ObservableValue<ICodeCoverageTreeItem | undefined>)[] {
        const filteredItems = [];

        if (filterText) {
            for (const path of Object.keys(items)) {
                const pageName = getFileName(path);

                if (caseInsensitiveContains(pageName, filterText)) {
                    filteredItems.push(items[path].data);
                }
            }

            const allFilteredItems = this.addParentPaths(filteredItems, items);
            return allFilteredItems;
        }

        return [];
    }

    private addParentPaths(
        filteredItems: (ICodeCoverageTreeItem | ObservableValue<ICodeCoverageTreeItem | undefined>)[],
        items: { [key: string]: ITreeItem<ICodeCoverageTreeItem | ObservableValue<ICodeCoverageTreeItem | undefined>> }
    ): (ICodeCoverageTreeItem | ObservableValue<ICodeCoverageTreeItem | undefined>)[] {
        let parentPaths: string[] = [];
        const additionalPaths: { [key: string]: boolean } = {};
        const existingPaths: { [key: string]: boolean } = {}; // to check if page already exists in results

        for (const item of filteredItems) {
            if (item && !ObservableLike.isObservable(item)) {
                const data = item as ICodeCoverageTreeItem;
                parentPaths = getParentPaths(data.path);
                existingPaths[data.path] = true;
            }

            for (const parent of parentPaths) {
                additionalPaths[parent] = true;
            }
        }

        for (const path of Object.keys(additionalPaths)) {
            if (!existingPaths[path]) {
                filteredItems.push(items[path].data);
            }
        }

        return filteredItems;
    }
}
Services.add("IAllTabViewService", { serviceFactory: AllTabViewService });
